import { IconName } from 'src/components';
import { Color } from 'src/utils/theme';
import { RecommendationsActivityType } from 'src/api/me/types';
import { LearningFeatureType } from 'src/api/learningQueue/types';

export const featureTypeToLicType: Record<LearningFeatureType, RecommendationsActivityType> = {
  learn: 'learn',
  pronunciation: 'learn',
  review: 'learn',
  video: 'immerse',
  conversation: 'communicate',
  sentence_builder: 'learn',
};

export const licTypeToIcon: Record<RecommendationsActivityType, IconName> = {
  learn: 'idea',
  communicate: 'communicateOutline',
  immerse: 'headphones',
} as const;

export const licTypeToColor: Record<RecommendationsActivityType, Color> = {
  learn: 'success40',
  communicate: 'information50',
  immerse: 'error60',
} as const;

export const licTypeToBackgroundColor: Record<RecommendationsActivityType, Color> = {
  learn: 'success98',
  communicate: 'information98',
  immerse: 'error98',
} as const;
